import { ADD_SALE } from "../../types/SaleType";
import axios from "axios";
import { toast } from "react-toastify";

const addPurchaseAciton = (data) => {
  return {
    type: ADD_SALE,
    payload: data,
  };
};

export const addSale = (data) => {
  return async (dispatch) => {
    try {
      const { data: invoice } = await axios({
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `sale-invoice/`,
        data
      });
      //dispatching data

      const newData = {
        ...invoice.createdInvoice,
        customer: invoice.customer,
      };

      dispatch(addPurchaseAciton(newData));
      toast.success("New Product Sold ");
      return {
        createdInvoiceId: invoice.createdInvoice.id,
        message: "success",
      };
    } catch (error) {
      console.log(error.message);
      return {
        message: "error",
      };
    }
  };
};
